module.exports = __webpack_public_path__ + "assets/img/536a26c1e0a51799084abeb33030f5c3.svg";